import { render, staticRenderFns } from "./queTask.vue?vue&type=template&id=4d0ddc2e&scoped=true&"
import script from "./queTask.vue?vue&type=script&lang=js&"
export * from "./queTask.vue?vue&type=script&lang=js&"
import style0 from "./queTask.vue?vue&type=style&index=0&id=4d0ddc2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ddc2e",
  null
  
)

export default component.exports